import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import {
    Backdrop,
    Button,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    CircularProgress,
    Container,
    Divider,
    Grid,
    Snackbar,
    Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import image from 'src/assets/images/konsep_2.jpg';
import { DataGrid } from '@material-ui/data-grid';
import * as XLSX from 'xlsx';
import axios from 'src/utils/axios';
import Alert from 'src/components/Alert';
import NakliyeButceOranlarOrnekExcel from 'src/assets/AssemblyBudgetExcels/5_NakliyeBütçeOranlarÖrnekExcelData.xlsx';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    media: {
        height: 300,
    },
    customCardContent: {
        '&.MuiCardContent-root:last-child': {
            paddingBottom: '0.65rem'
        }
    },
    dataGridHeader: {
        color: '#ff9800',
        fontWeight: 'bold',
        fontSize: '0.8rem'
    },
}));

function ShippingTotalCostCalculate() {
    const classes = useStyles();

    const [excelData, setExcelData] = useState([]);
    const [columns, setColumns] = useState([]);  // Excel'e göre dinamik kolonlar
    const [rows, setRows] = useState([]);  // Excel'e göre dinamik satırlar
    const [shippingBudgetTotalCostData, setShippingBudgetTotalCostData] = useState([]);

    const [successState, setSuccessState] = useState(false);

    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [loading, setLoading] = useState(false);
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    // Excel dosyasını okuma ve veri işleme fonksiyonu
    const handleFileUpload = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.xlsx, .xls';
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (evt) => {
                    const binaryStr = evt.target.result;
                    const workbook = XLSX.read(binaryStr, { type: 'binary' });

                    // İlk sayfayı alıyoruz
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName], { header: 1 });

                    if (worksheet.length > 0) {
                        // İlk satırdaki değerler kolonlar olacak
                        const newColumns = worksheet[0].map((col, index) => ({
                            field: `col_${index}`,
                            headerName: col,
                            width: index === 1 ? 300 : 200,  // İkinci kolon için genişlik 300, diğerleri 200
                            headerClassName: classes.dataGridHeader
                        }));

                        // Diğer satırları veri olarak ekliyoruz
                        const newRows = worksheet.slice(1).map((row, rowIndex) => {
                            const rowData = {};
                            row.forEach((cell, cellIndex) => {
                                rowData[`col_${cellIndex}`] = cell;
                            });
                            return { id: rowIndex + 1, ...rowData };
                        });

                        // Column ve row'ları state'e set et
                        setColumns(newColumns);
                        setRows(newRows);

                        // Excel verilerini sakla
                        setExcelData(newRows); // Gelen verileri sakla
                    }
                };
                reader.readAsBinaryString(file);
            }
        };
        fileInput.click();
    };

    const transformDataForApi = (data) => {
        return data.map(item => ({
            ProductLevelThree: item.col_0,
            ProductLevelFour: item.col_1,
            Brand: item.col_2,
            ModelType: item.col_3,
            Year: item.col_4,
            ShippingRate: item.col_5 != null ? item.col_5 : 0, // Eğer boşsa 0 atanır
            DealerParticipationRate: item.col_6 != null ? item.col_6 : 0, // Eğer boşsa 0 atanır
            LaborPrice: item.col_7 != null ? item.col_7 : 0, // Eğer boşsa 0 atanır
            ParticipationPrice: item.col_8 != null ? item.col_8 : 0, // Eğer boşsa 0 atanır
            FirstPeriodRaiseRatio: item.col_9 != null ? item.col_9 : 0, // Eğer boşsa 0 atanır
            SecondPeriodRaiseRatio: item.col_10 != null ? item.col_10 : 0 // Eğer boşsa 0 atanır
        }));
    };

    const handleCalculationInsertExcel = () => {
        setLoading(true);
        const data = transformDataForApi(excelData);
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('/ShippingBudgetTotalCostCalculationInsertExcel', data, config)
            .then(response => {
                if (response.data.ErrorCode === '1000') {
                    setresponseMessage(response.data.ErrorDescription)
                    setUyariTip("error");
                    setUyari(true);
                } else {
                    setSuccessState(true);

                    setresponseMessage(response.data.ErrorDescription)
                    setUyariTip("success");
                    setUyari(true);
                }
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });
    }

    const handleExecuteCalculation = () => {
        setLoading(true);
        axios.get('/ExecuteShippingBudgetCalculation').then((response) => {
            const data = response.data;
            setShippingBudgetTotalCostData(data);
            handleDownloadShippingBudgetCalculation();
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        })
    }

    const handleDownloadShippingBudgetCalculation = () => {
        setLoading(true);
        axios.get('/GetShippingBudgetDetail')
            .then((response) => {
                var data = response.data;
                exportToExcel(data);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const exportToExcel = (data) => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Nakliye Bütçe Hesaplama");
        XLSX.writeFile(wb, "Nakliye Bütçe Hesaplama.xlsx");
    };

    const handleDownloadExampleExcel = () => {
        const url = NakliyeButceOranlarOrnekExcel;
        const name = "5_NakliyeBütçeOranlarÖrnekExcelData.xlsx";

        if (url) {
            const a = document.createElement("a");
            a.href = url;
            a.download = name;
            a.click();
        }
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container maxWidth="xl">
                <Card>
                    <CardHeader title="Nakliye Bütçe Oranlar Hesaplama" />
                    <Divider />
                    <CardContent>
                        <Grid container spacing={5}>
                            {/* Kart 1 - Nakliye Bütçe Oranlar Exceli */}
                            <Grid item xs={12} sm={12} md={3} />
                            <Grid item xs={12} sm={12} md={6}>
                                <Card style={{ backgroundColor: successState ? 'lightgreen' : 'white' }}>
                                    <CardMedia className={classes.media} image={image} title="Nakliye Bütçe Oranlar Excel" />
                                    <CardContent className={classes.customCardContent}>
                                        <Typography gutterBottom variant="h5" component="h5" style={{ textAlign: 'center' }}>
                                            Nakliye Bütçe Oranlar Exceli
                                        </Typography>
                                        <Divider style={{ marginBottom: '0.6rem', backgroundColor: successState ? 'lightgreen' : '' }} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="secondary"
                                                    size="medium"
                                                    onClick={() => { handleDownloadExampleExcel(); }}
                                                    endIcon={<DownloadIcon />}
                                                >
                                                    Örnek Excel İndir
                                                </Button>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Button fullWidth variant="contained" color="secondary" size="medium" onClick={() => handleFileUpload()}>
                                                    Yükle
                                                    <UploadIcon style={{ marginLeft: '0.3rem' }} />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} />
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12}>
                                <DataGrid
                                    columns={columns}
                                    rows={rows}
                                    disableSelectionOnClick
                                    rowsPerPageOptions={[25, 50, 100, 200, 500]}
                                    style={{ height: 400, width: "100%" }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} />
                            <Grid item xs={12} sm={12} md={2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    size="medium"
                                    onClick={() => { handleCalculationInsertExcel(); }}
                                >
                                    Exceli Kaydet
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} />
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} />
                            <Grid item xs={12} sm={12} md={4}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    size="medium"
                                    onClick={() => { handleExecuteCalculation(); }}
                                >
                                    Nakliye Bütçe Çalıştır
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} />
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    )
}



export default ShippingTotalCostCalculate;